export default __webpack_public_path__ + "static/media/profile-page.b97e816b.png";